import * as d3 from 'd3';

/**
 * One shared zoom behavior for the whole engine. `onZoom(transform)` is
 * called on every zoom/pan tick; callers rescale their own x-scale from the
 * transform rather than this module owning any drawing.
 *
 * Zoom transform is stored on the overlay node itself (via d3.zoomTransform,
 * D3's own convention) so it survives React re-renders (e.g. toggling an
 * indicator) as long as the same DOM node is reused -- the old
 * implementation rebuilt `d3.zoom()` from scratch on every effect re-run,
 * silently resetting any in-progress zoom/pan.
 */
export function createZoom({ availableWidth, height, scaleExtent = [1, 20], onZoom }) {
  return d3
    .zoom()
    .scaleExtent(scaleExtent)
    .extent([[0, 0], [availableWidth, height]])
    .translateExtent([[0, 0], [availableWidth, height]])
    .on('zoom', (event) => onZoom(event.transform));
}

export function getCurrentTransform(node) {
  return node ? d3.zoomTransform(node) : d3.zoomIdentity;
}
